import React from 'react';
import "./Chats.css";
import Chat from "./Chat";
function Chats() {
    return (
        <div className="chats">

            <Chat
                name="Arefat"
                message="whats up?🎉🎉"
                timestamp="40 seconds ago"
                profilePic="https://lh3.googleusercontent.com/ogw/ADGmqu-pkZFESWirrPJ3yP83VOmOn-7HIGtbYx-fobfd=s32-c-mo"
            />
            <Chat
                name="Markos"
                message="whats up?🎇🎇"
                timestamp="4 minutes ago"
                profilePic="https://cdn4.iconfinder.com/data/icons/business-blue-series-set-1/64/Businessman_avatar_business_man_user-128.png"
            />
            <Chat
                name="Sandra"
                message="whats up?😎😎"
                timestamp="2 days ago"
                profilePic="https://images.pexels.com/photos/2787341/pexels-photo-2787341.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
            />

            <Chat
                name="Charlie"
                message="whats up?🔥"
                timestamp="40 seconds ago"
                profilePic="https://cdn3.iconfinder.com/data/icons/generic-avatars/128/avatar_portrait_man_male-128.png"
            />

            <Chat
                name="Willomina"
                message="whats up?🎁🎁"
                timestamp="40 minutes ago"
                profilePic="https://lh3.googleusercontent.com/ogw/ADGmqu-pkZFESWirrPJ3yP83VOmOn-7HGbYx-fobfd=s32-c-mo"
            />

        </div>
    )
}

export default Chats
